/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Address
 */
export interface Address {
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof Address
     */
    address: string;
    /**
     * 
     * @type {boolean}
     * @memberof Address
     */
    useForMounts?: boolean;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    priority?: number;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    network: number;
    /**
     * 
     * @type {number}
     * @memberof Address
     */
    _interface?: number | null;
}

export function AddressFromJSON(json: any): Address {
    return AddressFromJSONTyped(json, false);
}

export function AddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): Address {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'address': json['address'],
        'useForMounts': !exists(json, 'use_for_mounts') ? undefined : json['use_for_mounts'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
        'network': json['network'],
        '_interface': !exists(json, 'interface') ? undefined : json['interface'],
    };
}

export function AddressToJSON(value?: Address | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'address': value.address,
        'use_for_mounts': value.useForMounts,
        'priority': value.priority,
        'network': value.network,
        'interface': value._interface,
    };
}


